export default {
  select: {
    method: 'get',
    url: '/client/commodity/category/find?key=KEY'
  }
}
